import React from 'react';

export default function GameMessage() {
  return (
    <div className="game-message">Соберите все сокровища.</div>
  )
}